import { render } from "./ChipsWithTooltips.vue?vue&type=template&id=21b60fa4"
import script from "./ChipsWithTooltips.vue?vue&type=script&lang=js"
export * from "./ChipsWithTooltips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__